import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { InvestmentRecap } from '../../models/investment-recap.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-investment-overview',
  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './investment-overview.html'
})
export class InvestmentOverviewComponent extends AbstractComponent {
  investmentRecap = input.required<InvestmentRecap>();
 
  
}